import { createSlice } from "@reduxjs/toolkit";
import { getAllFaqs, addQuery, getPastquery } from "../thunks/faqThunk";

const initialState = {
  isFaqLoading: false,
  faqList: [],
  pastQueries: [],
};

const faqSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllFaqs.pending, (state) => {
        state.isFaqLoading = true;
      })
      .addCase(getAllFaqs.fulfilled, (state, action) => {
        ((state.isFaqLoading = false),
          (state.faqList = action.payload.data || []));
      })
      .addCase(getAllFaqs.rejected, (state) => {
        state.isFaqLoading = false;
      })
      .addCase(addQuery.pending, (state) => {
        state.isFaqLoading = true;
      })
      .addCase(addQuery.fulfilled, (state, action) => {
        ((state.isFaqLoading = false), (state.action = action.payload));
      })
      .addCase(addQuery.rejected, (state) => {
        state.isFaqLoading = false;
      })
      .addCase(getPastquery.pending, (state) => {
        state.isFaqLoading = true;
      })
      .addCase(getPastquery.fulfilled, (state, action) => {
        state.isFaqLoading = false;
        state.pastQueries = action.payload?.data?.queries || [];
        // console.log("Past query payload:", action.payload);
      })
      .addCase(getPastquery.rejected, (state) => {
        state.isFaqLoading = false;
      });
  },
});

export default faqSlice.reducer;
